<template>
	<div>
		<b-form>
			<b-row>
				<b-col xl="3" md="3" sm="12">
					<!-- <div class="mt-2 d-none">
						<label for="customer" class="font-weight-900 text-sm">Customer</label>
						<b-form-select
							id="customer"
							v-model="rfMapForm.customer"
							:options="customerOption"
							value-field="key"
							text-field="value"
						></b-form-select>
					</div> -->
					<!-- <div class="mt-2">
						<label for="msisdn" class="font-weight-900 text-sm">To MSISDN</label>
						<b-form-input
							id="to-msisdn"
							v-model="rfMapForm.to_msisdn"
							placeholder="Enter full MSISDN"
							type="number"
							:state="toMsisdnState"
						></b-form-input>
						<b-form-invalid-feedback :state="toMsisdnState">
							Please enter a valid MSISDN (10 or 11 digits)
						</b-form-invalid-feedback>
					</div>

          <div class="mt-2">
						<label for="msisdn" class="font-weight-900 text-sm">From MSISDN</label>
						<b-form-input
							id="from-msisdn"
							v-model="rfMapForm.from_msisdn"
							placeholder="Enter full MSISDN"
							type="number"
							:state="fromMsisdnState"
						></b-form-input>
						<b-form-invalid-feedback :state="fromMsisdnState">
							Please enter a valid MSISDN (10 or 11 digits)
						</b-form-invalid-feedback>
					</div> -->

					<div class="mt-2">
						<label for="period" class="font-weight-900 text-sm">Period</label>
						<b-form-select
							id="period"
							v-model="rfMapForm.period"
							:options="periodOption"
							value-field="key"
							text-field="value"
							@change="getSelectedDate(rfMapForm.period)"
						></b-form-select>
					</div>
					<div class="mt-2" v-if="rfMapForm.period === 'daily'">
						<label for="selectDay" class="col-form-label form-control-label">Select Day:</label>
						<base-input 
							type="date" 
							v-model="rfMapForm.dynamicDate" 
							id="selectDay" 
							@change="selectDate()" 
						/>
					</div>

					<div class="mt-2" v-if="rfMapForm.period === 'weekly'">
						<label for="selectWeek" class="col-form-label form-control-label">Select Week:</label>
						<base-input
							type="week"
							v-model="rfMapForm.dynamicDate"
							id="selectWeek"
							@change="selectWeek()"
						/>
					</div>

          <span v-if="rfMapForm.period === 'monthly'">
            <div class="mt-2">
              <label for="selectMonth" class="col-form-label form-control-label">Select Year:</label>
              <b-form-select
                id="selectMonth"
                v-model="year"
                :options="yearOption"
                value-field="key"
                text-field="value"
                @change="getCurrentMonth()"
              ></b-form-select>
            </div>
            
            <div class="mt-2">
              <label for="selectMonth" class="col-form-label form-control-label">Select Month:</label>
              <b-form-select
                id="selectMonth"
                v-model="rfMapForm.dynamicDate"
                :options="monthOption"
                value-field="key"
                text-field="value"
                @change="selectMonth()"
              ></b-form-select>
            </div>
          </span>
					<!-- <hr class="mt-3 mb-3" /> -->
					<div class="text-right mt-3">
						<base-button
              data-cy="map-tab-search-btn"
							type="primary"
							title="Search"
							size="sm"
							v-on:click="getLocationIds"
							:loading="loadingStatus"
							:disabled="submitDisabled"
							class="mb-3"
						>
							Update Map
						</base-button>
					</div>
				</b-col>
				<b-col xl="1" md="1" sm="12"></b-col>
				<b-col class="bg-light p-1" style="height: 610px" v-if="mapLoading">
				<!-- Data Volume By Region Card (map) -->
				<div class="text-center w-100">
					<p v-if="mapLoading">Searching for location data</p>
					<b-icon
						icon="three-dots"
						class="text-center"
						animation="cylon"
						font-scale="4"
						v-if="mapLoading"
					></b-icon>
				</div>
			</b-col>
			<b-col class="bg-light p-1" style="height: 610px" :class="{'d-none': mapLoading}">
				<div id="map" class="map-canvas" style="height: 100%"></div>
			</b-col>
			</b-row>
		</b-form>
		<b-row>
			<b-card class="w-100" id="locationTable">
				<b-card-header>
					<b-row>
						<b-col cols="auto" class="d-flex justify-content-center align-items-center" >
							<b-form-group
								label=""
								label-for="per-page-select"
								label-cols-sm="0"
								label-cols-md="0"
								label-cols-lg="0"
								label-align-sm="center"
								label-size="sm"
								class="mb-2 per-page-select"
							>
								<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
								<b-form-select
									id="per-page-select"
									class="diameter-report-select"
									v-model="perPage"
									:options="pageOptions"
									size="sm"
									v-on:input="changePageOption(perPage)"
								></b-form-select>
							</b-form-group>
						</b-col>
						<b-col class="d-flex justify-content-center align-items-center">
							<b-dropdown
								size="sm"
								variant="primary"
								toggle-class="text-decoration-none"
                menu-class="card-body p-0 m-0"
							>
								<template #button-content>
									Export Table Data
								</template>
								<b-dropdown-item
									@click="exportData('csv')"
								>
									Export as CSV
								</b-dropdown-item>
								<b-dropdown-item
									@click="exportData('xls')"
								>
									Export as XLS
								</b-dropdown-item>
							</b-dropdown>
						</b-col>
						<b-col cols="auto"  class="customer-table-select">
							<b-form-group
								label=""
								label-for="filter-input"
								label-align-sm="right"
								label-size="sm "
								class="mb-0 per-page-select"
							>
								<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
								<b-input-group size="sm">
									<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-row>
				</b-card-header>
				<b-card-body>
					<b-table
						:items="items"
						:fields="columns"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						:filter-included-fields="filterOn"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						:sort-direction="sortDirection"
						table-class="text-nowrap"
						class="primary-table text-center"
						sticky-header
						thead-class="white"
						show-empty
						responsive
						small
					>
						<template #cell(lat_lon)="row">
							<a
								role="button"
								@click="handleImsiClick(row.item)"
								title="Go to map location"
								style="cursor: pointer"
							>
								<i class="fas fa-map-marker-alt"></i>
								{{ row.item["lat_lon"] }}
							</a>
						</template>

						<template #cell(mcc)="row">
							{{ row.item["mcc"] }}{{ row.item["mnc"] }}
						</template>

						<template #empty="scope">
							<div v-if="loadingStatus" class="text-center">
								<b-icon icon="three-dots" animation="cylon" font-scale="4" />
							</div>
							<div v-else class="text-center">
								<b>{{ scope.emptyText }}</b>
							</div>
						</template>
						<template #emptyfiltered="scope">
							<h4>{{ scope.emptyFilteredText }}</h4>
						</template>
					</b-table>

					<b-row v-if="items.length > 0" class="mt-4">
						<b-col>
							<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
						</b-col>
						<b-col>
							<b-pagination
								v-if="totalRows > perPage"
								class="flex-fill-custom pr-4 ml-3 justify-content-end"
								v-model="currentPage"
								:total-rows="totalRows"
								:per-page="perPage"
								size="sm"
							></b-pagination>
						</b-col>
					</b-row>
				</b-card-body>
			</b-card>
		</b-row>
	</div>
</template>

<script>
import configDirective from "../../../../common/directive/config-directive";
import moment from "moment";
import rfDashboardServices from "../../../../common/api-services/rf-dashboard-service";
import pagination from "../../../../common/format/pagination";
import {exportToCSV, exportToExcel} from "@/common/export-to-csv";

export default {
	name: "rf-Map",
	components: {},
	computed: {
		fromMsisdnState() {
			if (this.rfMapForm.from_msisdn.length === 0) {
				return null;
			} else {
				return this.rfMapForm.from_msisdn.length > 9 && this.rfMapForm.from_msisdn.length < 12;
			}
		},
    toMsisdnState() {
      if (this.rfMapForm.to_msisdn.length === 0) {
        return null;
      } else {
        return this.rfMapForm.to_msisdn.length > 9 && this.rfMapForm.to_msisdn.length < 12;
      }
    },
		submitDisabled() {
			if (this.toMsisdnState === null && this.fromMsisdnState === null) {
				return false;
			} 
      return this.toMsisdnState === false || this.fromMsisdnState === false;
		},
		totalRows() {
			return this.items.length;
		},
	},
	data() {
		return {
			rfMapForm: {
				from_dt: "",
				to_dt: "",
				from_msisdn: "",
				to_msisdn: "",
				customer: "",
				period: "daily",
				dynamicDate: "",
				timeSeries: "1h",
				dataGrouping: "type",
			},
			periodOption: [
				// {key: "1h", value: "Last 1 hours"},
				// {key: "6h", value: "Last 6 hours"},
				// {key: "24h", value: "Last 24 hours"},
				{key: "daily", value: "Daily"},
				{key: "weekly", value: "Weekly"},
				{key: "monthly", value: "Monthly"},
			],
			seriesOption: [
				{key: "5m", value: "5 Minutes"},
				{key: "1h", value: "1 Hour"},
				{key: "1d", value: "1 Day"},
				{key: "7d", value: "1 Week"},
				{key: "30d", value: "1 Month"},
			],
			groupingOption: [
				{key: "", value: "Total Messages"},
				{key: "type", value: "Type"},
				{key: "command_id", value: "Command"},
				{key: "imsi", value: "IMSI"},
				{key: "orealm_req", value: "Realm"},
			],
			monthOption: [],
      yearOption: [],
      year: "",
			customerOption: [],
			selectDayStatus: false,
			selectWeekStatus: false,
			selectMonthStatus: false,
			loadingStatus: false,
			selectedDateFrom: "",
			selectedDateTo: "",
			timeRangeCondition: "",
			// Map Data
			items: [],
			markerList: [],
			heatmapLayer: [],
			mapLoading: false,
			map: null,
			startingCenter: null,
			client: "",
      searchExecuted: false,
			// Table Data
			columns: [
        {key: "carrier", label: "Carrier", sortable: true},
				{key: "date", label: "Date", sortable: true},
				{key: "cid", label: "CID", sortable: true},
				{key: "lac", label: "LAC", sortable: true},
				{key: "lat_lon", label: "LAT/LON", sortable: true},
				{key: "radio", label: "Radio", sortable: true},
				{key: "mcc", label: "MCC/MNC", sortable: true},
				{key: "count", label: "Count", sortable: true},
				{key: "Location_Info", label: "Location ID", sortable: true},
			],
			perPage: 10,
			currentPage: 1,
			pageOptions: [10, 25, 50, 100],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			fromPage: 0,
		};
	},
	mounted() {
		this.getCurrentDate();
    this.getCurrentYear();
		this.client = configDirective.getCarrier();
		this.loadMap(this.map);
	},
	methods: {

		async getLocationIds() {
      this.searchExecuted = true;
			this.loadingStatus = true;
			this.items = [];
			this.markerList = [];
			this.heatmapLayer = [];
			let payload = {
				index: `${this.client}-rf-*`,
				from_dt: this.rfMapForm.from_dt.replace("T", " ").replace("Z", ""),
				to_dt: this.rfMapForm.to_dt.replace("T", " ").replace("Z", ""),
				from_msisdn: this.rfMapForm.from_msisdn,
				to_msisdn: this.rfMapForm.to_msisdn,
				result_type: "graph",
				series: "Access_Network_Information",
				interval: "1d",
			};
			rfDashboardServices.getRfLocations(payload).then(async res => {
				// console.log("LOCATION:", res);

				if (typeof res === "object") {
					for (let key in res) {
						if (res[key].hasOwnProperty("lat_lon")) {
							res[key].date = moment(new Date(res[key].date)).format("MMM DD, YYYY");
							this.items.push(res[key])
						}
					}
				}
				this.loadMap(this.map);
			})
			.catch(err => {
				console.error("ERROR:", err);
			})
			.finally(() => {
				this.loadingStatus = false;
			});
		},

		exportData(format) {
			let fileName = `RF-Locations-${moment(this.startDate).format('MM-D-YYYY')}`;
			let load = structuredClone(this.items);
			load.forEach(item => {
				item['Date'] = moment(new Date(item.date)).format('MM-DD-YYYY');
				delete item.date;
				item['Location ID'] = item.Location_Info;
				delete item.Location_Info;
				item['CID'] = item.cid;
				delete item.cid;
				item['LAC'] = item.lac;
				delete item.lac;
				item['Connection Type'] = item.radio;
				delete item.radio;
				item['Count'] = item.count;
				delete item.count;
				item['LAT/LON'] = item.lat_lon.replace(",", " ");
				delete item.lat_lon;
				item['MCC'] = item.mcc;
				delete item.mcc;
				item['MNC'] = item.mnc;
				delete item.mnc;
			});
			if (format === 'csv') {
				exportToCSV(load, fileName);
			} else if (format === 'xls') {
				exportToExcel(load, fileName);
			}
		},

		handleImsiClick(obj) {
			// console.log("handleImsiClick:", obj);
			// console.log("MAP:", this.map.zoom);
			this.map.panTo(new google.maps.LatLng(obj.lat_lon.split(",")[0], obj.lat_lon.split(",")[1], true));
			this.map.setZoom(14);
			this.markerList.forEach(marker => {
				let lat = marker.getPosition().lat();
				let lng = marker.getPosition().lng();

				if (marker.title === String(obj.cid)) {
					marker.setAnimation(google.maps.Animation.DROP);
					let infowindow = new google.maps.InfoWindow({
						content:
							"<div> " +
							'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Carrier: </span> ' +
							obj.carrier +
							'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Date: </span> ' +
							obj.date +
							'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">CID: </span> ' +
							obj.cid +
							'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">LAC: </span> ' +
							obj.lac +
							'<br><p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">LAT/LON: </span> </b> ' +
							obj.lat_lon +
							'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Connection Type: </span> ' +
							obj.radio +
							'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">MCC/MNC: </span> ' +
							obj.mcc + obj.mnc +
							'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Location ID: </span> ' +
							obj.Location_Info +
							'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Count: </span> ' +
							obj.count +
							"</div>",
					});
					setTimeout(() => {
						infowindow.open(this.map, marker);
					}, 1000);
					
					marker.addListener("click", function () {
						infowindow.open(this.map, marker);
					});

					// close infowindow when zoom < 15
					google.maps.event.addListener(this.map, "zoom_changed", function () {
						// if (this.map.getZoom() < 15) {
							infowindow.close();
						// }
					});

					// close infowindow when click on map
					google.maps.event.addListener(this.map, "click", function () {
						infowindow.close();
					});
				} else if (obj.lat_lon === lat + ", " + lng) {
					// console.log("NO MATCH:", lat, lng);
					marker.setMap(null);
				}
			});
		},

		loadMap(map) {
			this.mapLoading = true;
			try {
				let configData = configDirective.getConfigData();
				let bound = new google.maps.LatLngBounds();

				let map_center = configData["site-settings"]["map_center"].split(",");
				let center = new google.maps.LatLng(map_center[0], map_center[1], true);
				let zoom = configData["site-settings"]["map_zoom"] ? configData["site-settings"]["map_zoom"] : 8;

				map = new google.maps.Map(document.getElementById("map"), {
					center: center,
					zoom: zoom,
					maxZoom: 17,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
				});

				// console.log("ITEMS:", [...this.items])
				if (this.items.length > 0) {
					for (let i in this.items) {
						let value = this.items[i];
						if (value != null) {
							this.addMarker(value, map, bound);
							this.heatmapLayer.push({
								location: new google.maps.LatLng(
									value.lat_lon.split(",")[0],
									value.lat_lon.split(",")[1]
								),
								weight: value.count,
							});
						}
					}
				} else {
					let default_value = {
						date: moment().format("YYYY-MM-DD"),
						imsi: "DEFAULT",
						lat_lon: map_center[0] + "," + map_center[1],
						data: "NULL",
						connectiontype: "NULL",
						operator: "NULL",
					};
					let defaultMarker = this.addMarker(default_value, map, bound);
          defaultMarker.setAnimation(google.maps.Animation.DROP);
          let content = 
              '<div> ' +
                '<p style="margin-top: 15px; font: bold 12px Roboto, serif; color: #34495e;"> No Data Found </p>' +
                '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Start Date: </span>' +
                  moment(`${this.rfMapForm.from_dt.split('T')[0]} ${this.rfMapForm.from_dt.split('T')[1].replace("Z", "")}`).format('MMM DD, YYYY hh:mm A') +
                '</p>' +
                '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">End Date: </span>' +
                  moment(`${this.rfMapForm.to_dt.split('T')[0]} ${this.rfMapForm.to_dt.split('T')[1].replace("Z", "")}`).format('MMM DD, YYYY hh:mm A') +
                '</p>' +
              "</div>";
          if (!this.searchExecuted) {
            content = 
              '<div> ' +
              '<p style="max-width: 150px; margin-top: 15px; font: bold 12px Roboto, serif; color: #34495e;"> Please select a date range and click "Update Map" to search for location data </p>' +
              "</div>";
          }
          let infowindow = new google.maps.InfoWindow({
            content: content
          });
          setTimeout(() => {
            infowindow.open(this.map, defaultMarker);
          }, 1000);
				}

				// console.log("HEATMAP:", this.heatmapLayer);
				if (this.heatmapLayer.length > 0) {
					if (this.markerList) {
						this.markerList.forEach(marker => {
							marker.setMap(null);
						});
					}
				}

				let heatmap = new google.maps.visualization.HeatmapLayer({
					data: this.heatmapLayer,
					map: map,
				});
				heatmap.setMap(map);
				heatmap.set("radius", 35);

				// Calculate the center of the heatmap data
				let latSum = 0;
				let lonSum = 0;
				this.heatmapLayer.forEach(dataPoint => {
					latSum += dataPoint.location.lat();
					lonSum += dataPoint.location.lng();
				});
				const dataCenter = new google.maps.LatLng(
					latSum / this.heatmapLayer.length,
					lonSum / this.heatmapLayer.length
				);

				if (this.heatmapLayer.length > 0) {
					this.startingCenter = dataCenter;
				} else {
					this.startingCenter = center;
				}
				
				// Set map center and initial zoom
				map.setCenter(this.startingCenter);
				map.setZoom(9);

				// Create "Center Map" button and add it to the map
				const centerControlDiv = document.createElement("div");
				const centerControl = this.createCenterControl(map, bound);

				centerControlDiv.appendChild(centerControl);
				map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);

				// Define max and min zoom levels
				// const maxZoom = 15;
				const minZoomToShowMarkers = 8;

				google.maps.event.addListener(map, "zoom_changed", () => {
					const currentZoom = map.getZoom();

					if (currentZoom <= minZoomToShowMarkers) {
						// Remove markers and show only heatmap
						if (heatmap) {
							heatmap.setMap(map);
						}
						if (this.markerList) {
							this.markerList.forEach(marker => {
								marker.setMap(null);
							});
						}
					} else {
						// Show markers and heatmap
						if (heatmap) {
							heatmap.setMap(null);
						}
						if (this.markerList) {
							this.markerList.forEach(marker => {
								marker.setMap(map);
							});
						}
					}

					// Limit zoom level
					// if (currentZoom > maxZoom) {
					// 	map.setZoom(maxZoom);
					// }
				});

				// Set map center and zoom to fit all markers
				google.maps.event.addListener(map, "zoom_changed", function () {
					const zoomChangeBoundsListener = google.maps.event.addListener(
						map,
						"bounds_changed",
						function (event) {
							if (this.getZoom() > 15 && this.initialZoom == true) {
								this.setZoom(15);
								this.initialZoom = false;
							}
							google.maps.event.removeListener(zoomChangeBoundsListener);
						}
					);
				});

				map.initialZoom = true;
				map.fitBounds(bound);
				this.map = map;
			} catch (error) {
				console.error("CAUGHT-MAP: ", error);
			} finally {
				this.mapLoading = false;
			}
		},

		addMarker(data, map, bound) {
			// console.log("MARKER:", data);

			let sel_icon = "https://i.imgur.com/2eE096C.png";
			if (data.radio == "3G") {
				//green triangle
				sel_icon = "https://i.imgur.com/vSpGkBd.png";
			} else if (data.radio == "LTE") {
				//green square
				sel_icon = "https://i.imgur.com/8jLOZnY.png";
			}

			let lat_lon = data.lat_lon.split(",");
			let lat = lat_lon[0];
			let lon = lat_lon[1];
			let latlng = new google.maps.LatLng(lat, lon);
			bound.extend(latlng);
			let marker = new google.maps.Marker({
				position: {
					lat: parseFloat(lat),
					lng: parseFloat(lon),
				},
				map: map,
				icon: sel_icon,
				title: String(data.cid),
			});
			let infowindow = new google.maps.InfoWindow({
				content:
					"<div> " +
					'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Carrier: </span> ' +
					data.carrier +
					'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Date: </span> ' +
					data.date +
					'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">CID: </span> ' +
					data.cid +
					'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">LAC: </span> ' +
					data.lac +
					'<br><p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">LAT/LON: </span> </b> ' +
					data.lat_lon +
					'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Connection Type: </span> ' +
					data.radio +
					'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">MCC/MNC: </span> ' +
					data.mcc + data.mnc +
					'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Location ID: </span> ' +
					data.Location_Info +
					'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Count: </span> ' +
					data.count +
					"</div>",
			});
			marker.addListener("click", function () {
				infowindow.open(map, marker);
			});

			// close infowindow when zoom < 15
			google.maps.event.addListener(map, "zoom_changed", function () {
				if (map.getZoom() < 15) {
					infowindow.close();
				}
			});

			// close infowindow when click on map
			google.maps.event.addListener(map, "click", function () {
				infowindow.close();
			});

			bound.extend(marker.position);
			map.fitBounds(bound);

			this.markerList.push(marker);
      return marker;
		},

		createCenterControl(map, bound) {
			const controlButton = document.createElement("button");

			// Set CSS for the control.
			controlButton.style.backgroundColor = "#fff";
			controlButton.style.border = "2px solid #fff";
			controlButton.style.borderRadius = "3px";
			controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
			controlButton.style.color = "rgb(25,25,25)";
			controlButton.style.cursor = "pointer";
			controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
			controlButton.style.fontSize = "16px";
			controlButton.style.lineHeight = "38px";
			controlButton.style.margin = "8px 0 22px";
			controlButton.style.padding = "0 5px";
			controlButton.style.textAlign = "center";

			controlButton.textContent = "Recenter";
			controlButton.title = "Click to recenter the map";
			controlButton.type = "button";

			controlButton.addEventListener("click", () => {
				// map.setCenter(this.startingCenter);

				this.map.panTo(this.startingCenter)
				map.fitBounds(bound);
			});

			return controlButton;
		},

		getSelectedDate(option) {
			switch (option) {
				case "daily": {
					this.selectDayStatus = true;
					this.selectWeekStatus = false;
					this.selectMonthStatus = false;
					this.getCurrentDate();
					break;
				}
				case "weekly": {
					this.selectWeekStatus = true;
					this.selectDayStatus = false;
					this.selectMonthStatus = false;
					this.getCurrentWeek();
					break;
				}
				case "monthly": {
					this.selectMonthStatus = true;
					this.selectDayStatus = false;
					this.selectWeekStatus = false;
					this.getCurrentMonth();
					break;
				}
				default:
					this.selectMonthStatus = false;
					this.selectDayStatus = false;
					this.selectWeekStatus = false;
					break;
			}
		},

		getCurrentDate() {
			let date = new Date();
			let thisYear = date.getFullYear();
			let thisDate = date.getDate();
			let thisMonth = date.getMonth() + 1;
			if (thisDate < 10) {
				thisDate = "0" + thisDate;
			}
			if (thisMonth < 10) {
				thisMonth = "0" + thisMonth;
			}
			this.rfMapForm.dynamicDate = thisYear + "-" + thisMonth + "-" + thisDate;
			this.selectDate();
		},

		getCurrentWeek() {
			let today = new Date();
			let year = today.getFullYear();
			let oneJan = new Date(year, 0, 1);
			let numberOfDays = Math.floor((today - oneJan) / (24 * 60 * 60 * 1000));
			let result = Math.floor((today.getDay() + 1 + numberOfDays) / 7);
			this.rfMapForm.dynamicDate = year + "-W" + result;
			this.selectWeek();
		},

		getCurrentMonth() {
			this.monthOption = [];
			let monthNames = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];
			let today = new Date()
      today.setFullYear(this.year);
			let year = this.year;
			// let month = today.getMonth() + 1;

      // Calculate and set month options
			// let i = 0;
			// do {
			// 	let key = (month > 9 ? "" : "0") + month + "/01/" + year;
			// 	let value = monthNames[month - 1] + " " + year;
			// 	this.monthOption.push({
			// 		key: key,
			// 		value: value,
			// 	});
			// 	if (month - 1 < 1) {
			// 		month = 13;
			// 	}
			// 	if (month === 0) {
			// 		month = 11;
			// 		year--;
			// 	} else {
			// 		month--;
			// 	}
			// 	i++;
			// } while (i < 12);

      monthNames.forEach((month, index) => {

        let key = (index + 1 > 9 ? "" : "0") + (index + 1) + "/01/" + year;
        let value = month + " " + year;
        this.monthOption.push({
          key: key,
          value: value,
        });
      });
			// console.log(moment().date(1).year(this.year).format("MM/DD/YYYY"))
			this.rfMapForm.dynamicDate = moment().date(1).year(this.year).format("MM/DD/YYYY");
			this.selectMonth();
		},

    getCurrentYear() {
      let today = new Date();
      let year = today.getFullYear();
      this.yearOption = [];
      for (let i = 5; i > 0; i--) {
        this.yearOption.push({
          key: year - i,
          value: year - i,
        });
      }
      this.yearOption.push({
        key: year,
        value: year,
      });
      this.year = year;
    },

		getTimeRangeCondition(period) {
			let timeRangeCondition;
			switch (period) {
				case "24h": {
					timeRangeCondition = "time >= now() - " + this.rfMapForm.period;
					break;
				}
				case "6h": {
					timeRangeCondition = "time >= now() - " + this.rfMapForm.period;
					break;
				}
				case "1h": {
					timeRangeCondition = "time >= now() - " + this.rfMapForm.period;
					break;
				}
				case "daily": {
					timeRangeCondition =
						"time >= '" + this.selectedDateFrom + "' AND time <= '" + this.selectedDateTo + "' ";
					break;
				}
				case "weekly": {
					timeRangeCondition =
						"time >= '" + this.selectedDateFrom + "' AND time <= '" + this.selectedDateTo + "' ";
					break;
				}
				case "monthly": {
					timeRangeCondition =
						"time >= '" + this.selectedDateFrom + "' AND time <= '" + this.selectedDateTo + "' ";
					break;
				}
				default:
					break;
			}
			return timeRangeCondition;
		},

		selectDate() {
			let firstDay = moment(this.rfMapForm.dynamicDate).format("YYYY-MM-DDT00:00:00") + "Z";
			let lastDay = moment(this.rfMapForm.dynamicDate).format("YYYY-MM-DDT23:59:00") + "Z";
			// console.log("FIRST:", firstDay);
			// console.log("LAST:", lastDay);
			this.rfMapForm.from_dt = firstDay
			this.rfMapForm.to_dt = lastDay;
		},

		selectWeek() {
			// console.log("WEEK:", this.rfMapForm.dynamicDate);
			let weekNum = this.rfMapForm.dynamicDate.split("W")[1];
			let year = this.rfMapForm.dynamicDate.split("-")[0].trim();

			let firstDay = moment().day("Monday").year(year).week(Number(weekNum)).format("YYYY-MM-DDT00:00:00") + "Z";
			let lastDay = moment().day("Sunday").year(year).week(Number(weekNum) + 1).format("YYYY-MM-DDT23:59:00") + "Z";
			// console.log("FIRST:", firstDay);
			// console.log("LAST:", lastDay);

			this.rfMapForm.from_dt = firstDay;
			this.rfMapForm.to_dt = lastDay;
		},

		selectMonth() {
			let date = new Date(this.rfMapForm.dynamicDate);
			// console.log(date)
			let y = date.getFullYear();
			let m = date.getMonth();
			let firstDay = moment(new Date(y, m, 1)).format("YYYY-MM-DDT00:00:00") + "Z";
			let lastDay = moment(new Date(y, m + 1, 0)).format("YYYY-MM-DDT23:59:00") + "Z";
			// console.log("FIRST:", firstDay);
			// console.log("LAST:", lastDay);
			this.rfMapForm.from_dt = firstDay;
			this.rfMapForm.to_dt = lastDay;
		},

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},

		changePageOption(page) {
			this.getTotalRows();
		},

		startPage() {
			return pagination.startPageFunc(this.currentPage, this.perPage);
		},

		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows);
		},
	},
};
</script>

<style scoped>
.loading-icon-style {
	position: fixed;
	height: 40%;
}
.cursor-no-allowed {
	cursor: not-allowed;
}
</style>
